import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { formatNumber } from '@/helpers/format/formatNumber.js';
import { Palette } from '@/themes/themeOverrides/Palette';

export const StyledChip = styled(Chip)(() => ({
    marginLeft: '13px',
    height: 28,
    borderRadius: '8px',
    '& .MuiChip-label': {
        fontSize: '14px',
        fontWeight: '600',
        color: Palette.black,
        padding: '0 7px',
    },
    '&.growth--small': {
        height: 20,
        borderRadius: '4px',
        marginLeft: '8px',
        '& .MuiChip-label': {
            fontSize: '11px',
            fontWeight: '400',
            padding: '2px 4px',
        },
    },
}));

export const Growth = ({ value, className, reverse = false, decimalPlaces = 0, sx }) => {
    if (!isFinite(value)) {
        return null;
    }

    return (
        <StyledChip
            label={`${value > 0 ? '+' : ''}${formatNumber(value, decimalPlaces)}%`}
            sx={{ backgroundColor: getColor(value, reverse), ...sx }}
            className={className}
        />
    );
};
const getColor = (value, reverse) => {
    if (value === 0) {
        return 'default';
    }

    if (reverse) {
        return value > 0 ? Palette.red.red200 : Palette.green.green300;
    }

    return value > 0 ? Palette.green.green300 : Palette.red.red200;
};
